import { render } from "./AgeBreakdownModal.vue?vue&type=template&id=432b0e3a&scoped=true"
import script from "./AgeBreakdownModal.vue?vue&type=script&lang=js"
export * from "./AgeBreakdownModal.vue?vue&type=script&lang=js"

import "./AgeBreakdownModal.vue?vue&type=style&index=0&id=432b0e3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-432b0e3a"]])

export default __exports__